/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  ALGO_BULK_ERRORS_CLEAR_RETRY_ATTEMPT_COUNT,
  ALGO_BULK_ERRORS_FILTERS,
  ALGO_BULK_ERRORS_SORTING,
  ALGO_BULK_ERRORS_UPDATE_BULK_VALUE,
  ALGO_BULK_ERRORS_UPDATE_RETRY_ATTEMPT_COUNT,
  ALGO_BULK_ERRORS_UPDATE_SELECT_ALL,
  ALGO_BULK_ERRORS_UPDATE_VALUE,
  FETCH_ALGO_BULK_ERRORS_FAILURE,
  FETCH_ALGO_BULK_ERRORS_REQUEST,
  FETCH_ALGO_BULK_ERRORS_RESET,
  FETCH_ALGO_BULK_ERRORS_SUCCESS,
  FETCH_ALGO_BULK_ERRORS_UPDATE_DATA_CACHED,
  UPDATE_ALGO_BULK_ERRORS_FILTERS,
  UPDATE_ALGO_BULK_ERRORS_SORTING,
} from '../../constants/ActionTypes';
import { readBuffer } from '../../utils';
import storage from '../../storage';
import {
  clearRetryAttemptCounts,
  updateRetryAttemptCounts,
  updateSelectAll,
  updateValue,
  updateValueBulk,
} from './updators';

function listData() {
  return {
    isFetching: false,
    errors: {},
    dataUpdatedAt: null,
    dataCachedUpdatedAt: null,
    data: [],
    clientIds: [],
    dataCached: [],
    retryAttempts: [],
  };
}

const list = (state = listData(), action) => {
  switch (action.type) {
    case FETCH_ALGO_BULK_ERRORS_RESET:
      return { ...listData() };
    case FETCH_ALGO_BULK_ERRORS_REQUEST:
      return { ...state, isFetching: true, errors: {} };
    case FETCH_ALGO_BULK_ERRORS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.data.data,
        clientIds: action.data.clientIds,
        dataUpdatedAt: Date.now(),
        errors: {},
      };
    case FETCH_ALGO_BULK_ERRORS_UPDATE_DATA_CACHED:
      return {
        ...state,
        dataCached: action.data,
        dataCachedUpdatedAt: Date.now(),
      };
    case FETCH_ALGO_BULK_ERRORS_FAILURE:
      return { ...state, isFetching: false, errors: action.errors };
    case ALGO_BULK_ERRORS_UPDATE_VALUE:
      const valueUpdated = updateValue(state, action);

      if (valueUpdated.dataCachedUpdatedAt === state.dataCachedUpdatedAt) {
        return state;
      } else {
        return {
          ...state,
          dataCached: valueUpdated.data,
          data: valueUpdated.dataCached,
          dataCachedUpdatedAt: valueUpdated.dataCachedUpdatedAt,
        };
      }
    case ALGO_BULK_ERRORS_UPDATE_BULK_VALUE:
      const valueBulkUpdated = updateValueBulk(state, action);

      if (valueBulkUpdated.dataCachedUpdatedAt === state.dataCachedUpdatedAt) {
        return state;
      } else {
        return {
          ...state,
          dataCached: valueBulkUpdated.data,
          data: valueBulkUpdated.dataCached,
          dataCachedUpdatedAt: valueBulkUpdated.dataCachedUpdatedAt,
        };
      }
    case ALGO_BULK_ERRORS_UPDATE_SELECT_ALL:
      const valueSelectAll = updateSelectAll(state, action);

      if (valueSelectAll.dataCachedUpdatedAt === state.dataCachedUpdatedAt) {
        return state;
      } else {
        return {
          ...state,
          dataCached: valueSelectAll.data,
          data: valueSelectAll.dataCached,
          dataCachedUpdatedAt: valueSelectAll.dataCachedUpdatedAt,
        };
      }
    case ALGO_BULK_ERRORS_UPDATE_RETRY_ATTEMPT_COUNT:
      const retryAttemptsUpdate = updateRetryAttemptCounts(state, action);

      return {
        ...state,
        retryAttempts: retryAttemptsUpdate,
      };
    case ALGO_BULK_ERRORS_CLEAR_RETRY_ATTEMPT_COUNT:
      const retryAttemptsClear = clearRetryAttemptCounts(state, action);

      return {
        ...state,
        retryAttempts: retryAttemptsClear,
      };
    default:
      return state;
  }
};

const getFilterFromStorage = () => readBuffer(ALGO_BULK_ERRORS_FILTERS) || {};
const getSortFromStorage = () =>
  storage.getItem(ALGO_BULK_ERRORS_SORTING) || {};

const filters = (
  state = {
    filters: getFilterFromStorage(),
    sorting: getSortFromStorage(),
    filtersUpdatedAt: null,
    sortingUpdatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_ALGO_BULK_ERRORS_FILTERS:
      return { ...state, filters: action.data, filtersUpdatedAt: Date.now() };
    case UPDATE_ALGO_BULK_ERRORS_SORTING:
      return {
        ...state,
        sorting: action.data,
        sortingUpdatedAt: Date.now(),
      };
    default:
      return state;
  }
};

const algoBulkErrors = combineReducers({
  list,
  filters,
});

export default algoBulkErrors;
